/* eslint-disable */
<template>
  <div class="register-page">

    <div class="register-container">

      <!-- Left: Branding Panel -->
      <div class="branding-panel">
        <div class="branding-content">

          <div class="brand-gov-badge">LG</div>

          <h1 class="brand-title">Create Your Account</h1>
          <p class="brand-subtitle">Register to access local government online payment services</p>
          <p class="brand-sinhala">පළාත් පාලන සේවාවන් සඳහා ඔබගේ ගිණුම ලියාපදිංචි කරන්න</p>

          <div class="features-list">
            <div class="feature-item">
              <div class="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
                </svg>
              </div>
              <div class="feature-text">
                <strong>Assessment Tax</strong>
                <span>Pay property tax online | වරිපනම් බදු</span>
              </div>
            </div>

            <div class="feature-item">
              <div class="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
                </svg>
              </div>
              <div class="feature-text">
                <strong>Shop Rent</strong>
                <span>Pay monthly shop rent | කඩ කුලී ගෙවිම</span>
              </div>
            </div>

            <div class="feature-item">
              <div class="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                </svg>
              </div>
              <div class="feature-text">
                <strong>Online Booking</strong>
                <span>Book equipment &amp; venues | වෙන් කිරීම්</span>
              </div>
            </div>

            <div class="feature-item">
              <div class="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
                </svg>
              </div>
              <div class="feature-text">
                <strong>Secure &amp; Fast</strong>
                <span>Bank-grade security | 24/7 access</span>
              </div>
            </div>
          </div>

        </div>

        <div class="branding-footer">
          <p>Ministry of Public Administration, Home Affairs,<br>Provincial Councils &amp; Local Government</p>
        </div>
      </div>

      <!-- Right: Form Panel -->
      <div class="form-panel">
        <div class="form-inner">

          <!-- Form Header -->
          <div class="form-header">
            <div class="form-header-bar"></div>
            <div>
              <p class="form-breadcrumb">Local Government Payment System</p>
              <h2 class="form-title">Register</h2>
              <p class="form-subtitle">ගිණුමක් සාදන්න | Fill in the details below</p>
            </div>
          </div>

          <!-- Already-registered banner -->
          <transition name="fade">
            <div class="account-exists-banner" v-if="accountExists">
              <div class="banner-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <div class="banner-text">
                <strong>You're already registered</strong>
                <span>An account with this NIC already exists. <router-link @click="scrollToTop()" to="/">Sign in instead</router-link></span>
              </div>
            </div>
          </transition>

          <form id="registerForm" @submit="handleSubmit" novalidate autocomplete="off">

            <!-- ── Location Section ── -->
            <div class="section-label">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
              </svg>
              Location
            </div>

            <div class="field-grid three-col">
              <div class="field-group">
                <label class="field-label" for="province">Province <span class="req">*</span></label>
                <div class="input-wrap">
                  <select @change="changeprovince" v-model="registerObj.pro" id="province" class="field-input select-input" :class="{ filled: registerObj.pro }">
                    <option value="" disabled>Choose Province</option>
                    <option v-for="f in province" :key="f.pro_id" :value="f.pro_code">{{ f.pro_name }}</option>
                  </select>
                  <div class="select-chevron">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                    </svg>
                  </div>
                </div>
                <p class="error-mess" v-if="errorObj.proErr.length > 0">{{ errorObj.proErr[0] }}</p>
              </div>

              <div class="field-group">
                <label class="field-label" for="district">District <span class="req">*</span></label>
                <div class="input-wrap">
                  <select @change="changedist" v-model="registerObj.dis" id="district" class="field-input select-input" :class="{ filled: registerObj.dis }">
                    <option value="" disabled>Choose District</option>
                    <option v-for="ds in Districts" :key="ds.dist_code" :value="ds.dist_code">{{ ds.dist_name }}</option>
                  </select>
                  <div class="select-chevron">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                    </svg>
                  </div>
                </div>
                <p class="error-mess" v-if="errorObj.disErr.length > 0">{{ errorObj.disErr[0] }}</p>
              </div>

              <div class="field-group">
                <label class="field-label" for="pradeshiya">Pradeshiya Sabha <span class="req">*</span></label>
                <div class="input-wrap">
                  <select v-model="registerObj.pra_sabha" id="pradeshiya" class="field-input select-input" :class="{ filled: registerObj.pra_sabha }">
                    <option value="" disabled>Choose Sabha</option>
                    <option v-for="ps in p_sabha" :key="ps.sb_code" :value="ps.sb_code">{{ ps.sb_name_en }} | {{ ps.sb_name_sin }}</option>
                  </select>
                  <div class="select-chevron">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                    </svg>
                  </div>
                </div>
                <p class="error-mess" v-if="errorObj.praErr.length > 0">{{ errorObj.praErr[0] }}</p>
              </div>
            </div>

            <div class="section-divider"></div>

            <!-- ── Personal Info Section ── -->
            <div class="section-label">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
              </svg>
              Personal Information
            </div>

            <div class="field-grid two-col">
              <div class="field-group">
                <label class="field-label" for="uName">Full Name <span class="req">*</span></label>
                <div class="input-wrap">
                  <input type="text" id="uName" placeholder="e.g. RMSP KUMARA" class="field-input" :class="{ filled: registerObj.name }" v-model="registerObj.name" />
                  <div class="input-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                    </svg>
                  </div>
                </div>
                <p class="error-mess" v-if="errorObj.nameErr.length > 0">{{ errorObj.nameErr[0] }}</p>
              </div>

              <div class="field-group">
                <label class="field-label" for="uNic">NIC Number <span class="req">*</span></label>
                <div class="input-wrap">
                  <input type="text" id="uNic" placeholder="Enter your NIC" class="field-input" :class="{ filled: registerObj.nic }" v-model="registerObj.nic" />
                  <div class="input-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4z"/>
                    </svg>
                  </div>
                </div>
                <p class="error-mess" v-if="errorObj.nicErr.length > 0">{{ errorObj.nicErr[0] }}</p>
              </div>

              <div class="field-group">
                <label class="field-label" for="uAddress">Address <span class="req">*</span></label>
                <div class="input-wrap">
                  <input type="text" id="uAddress" placeholder="Enter your address" class="field-input" :class="{ filled: registerObj.address }" v-model="registerObj.address" />
                  <div class="input-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3"/>
                    </svg>
                  </div>
                </div>
                <p class="error-mess" v-if="errorObj.addressErr.length > 0">{{ errorObj.addressErr[0] }}</p>
              </div>

              <div class="field-group">
                <label class="field-label" for="uPhone">Mobile Number <span class="req">*</span></label>
                <div class="input-wrap otp-wrap">
                  <input
                    type="tel"
                    id="uPhone"
                    placeholder="Enter 10-digit number"
                    class="field-input otp-phone-input"
                    :class="{ filled: registerObj.phone }"
                    v-model="registerObj.phone"
                    :disabled="otpVerified"
                    maxlength="10"
                  />
                  <div class="input-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                    </svg>
                  </div>
                  <button
                    type="button"
                    class="otp-send-btn"
                    :class="{ verified: otpVerified }"
                    @click="sendOtp"
                    :disabled="!canSendOtp || sendingOtp || otpVerified"
                  >
                    {{ otpVerified ? 'Verified ✓' : (sendingOtp ? 'Sending…' : (otpSent ? 'Resend' : 'Send OTP')) }}
                  </button>
                </div>
                <p class="error-mess" v-if="errorObj.phoneErr.length > 0">{{ errorObj.phoneErr[0] }}</p>

                <div class="otp-verify-row" v-if="otpSent && !otpVerified">
                  <input
                    type="text"
                    inputmode="numeric"
                    maxlength="6"
                    placeholder="Enter 6-digit OTP"
                    class="field-input otp-code-input"
                    v-model="otp"
                  />
                  <button
                    type="button"
                    class="otp-verify-btn"
                    @click="verifyOtpCode"
                    :disabled="otp.length !== 6 || verifyingOtp"
                  >
                    {{ verifyingOtp ? 'Verifying…' : 'Verify' }}
                  </button>
                </div>
                <p class="otp-hint" v-if="otpSent && !otpVerified">OTP sent to {{ maskedPhone || registerObj.phone }}</p>
                <p class="error-mess" v-if="errorObj.otpErr.length > 0">{{ errorObj.otpErr[0] }}</p>
                <p class="otp-verified-msg" v-if="otpVerified">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
                  </svg>
                  Mobile number verified
                </p>
              </div>
            </div>

            <!-- Submit -->
            <div class="form-actions">
              <p class="login-hint">Already have an account? <router-link @click="scrollToTop()" to="/" class="login-link">Sign in here</router-link></p>
              <button type="submit" class="submit-btn" :disabled="!otpVerified" :title="!otpVerified ? 'Verify your mobile number first' : ''">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"/>
                </svg>
                Create Account
              </button>
            </div>

          </form>

          <div class="panel-footer">
            <p>&copy; {{ new Date().getFullYear() }} Local Government Payment System. All rights reserved.</p>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>


<script>
import axios from 'axios';
export default {
  name: "Register",
  data() {
    return {
      registerObj: { pro: "", dis: "", pra_sabha: "", name: "", nic: "", email: "test@gmail.com", address: "", phone: "", status: "0" },
      errorObj: { disErr: [], proErr: [], praErr: [], nameErr: [], nicErr: [], emailErr: [], addressErr: [], phoneErr: [], otpErr: [] },
      matchUser: undefined,
      paddedNum: null, len: '',
      p_sabha: [], Districts: [], province: [],
      // OTP verification state
      otp: '',
      otpSent: false,
      otpVerified: false,
      sendingOtp: false,
      verifyingOtp: false,
      maskedPhone: '',
      // Duplicate-account state
      accountExists: false,
    };
  },
  computed: {
    canSendOtp() {
      return /^[0-9]{10}$/.test(this.registerObj.phone);
    },
  },
  watch: {
    'registerObj.nic'() {
      // clear the "already registered" banner once the user starts editing the NIC again
      if (this.accountExists) this.accountExists = false;
    },
  },
  created() {
    this.AllDistricts();
    this.Allprovince();
    this.AllprSabha();
  },
  methods: {
    async getMatchUser(nic) {
      let data = await axios.get('/customersdata/' + nic);
      this.matchUser = data.data;
    },
    scrollToTop() { window.scrollTo(0, 0); },
    addZero(num) {
      num = num.toString();
      return '19' + num.slice(0, 5) + '0' + num.slice(5, -1);
    },
    addZeroPadding() {
      this.len = this.registerObj.nic.charAt(9).toUpperCase();
      if (!isNaN(parseInt(this.registerObj.nic)) && this.registerObj.nic !== null &&
        (this.registerObj.nic.charAt(9).toUpperCase() === 'V' || this.registerObj.nic.charAt(9).toUpperCase() === 'X')) {
        this.paddedNum = this.addZero(this.registerObj.nic);
      } else { this.paddedNum = parseInt(this.registerObj.nic); }
      return this.paddedNum;
    },
    async Allprovince() { this.province = (await axios.get('/provinces/')).data; },
    async AllDistricts() { this.Districts = (await axios.get('/districts/')).data; },
    async AllprSabha() { this.p_sabha = (await axios.get('/Prasabha/')).data; },
    async changeprovince() {
      let d = await axios.get('/districts/' + this.registerObj.pro);
      this.Districts = d.data;
    },
    async changedist() {
      let s = await axios.get('/Prasabha/' + this.registerObj.dis);
      this.p_sabha = s.data;
    },
    // ── OTP: send code to entered mobile number ──
    async sendOtp() {
      this.errorObj.otpErr = [];
      if (!this.canSendOtp) {
        this.errorObj.phoneErr = ['Enter a valid 10-digit mobile number first'];
        return;
      }
      this.sendingOtp = true;
      try {
        const res = await axios.post('/register-send-otp', { phone: this.registerObj.phone });
        this.maskedPhone = res.data.phone_masked || this.registerObj.phone;
        this.otpSent = true;
        this.otp = '';
      } catch (err) {
        const code = err.response?.data?.error;
        if (code === 'sms_not_configured') this.errorObj.otpErr = ['SMS service is unavailable right now, please try again later'];
        else this.errorObj.otpErr = ['Failed to send OTP, please try again'];
      } finally {
        this.sendingOtp = false;
      }
    },
    // ── OTP: verify code entered by user ──
    async verifyOtpCode() {
      this.errorObj.otpErr = [];
      this.verifyingOtp = true;
      try {
        await axios.post('/register-verify-otp', { phone: this.registerObj.phone, otp: this.otp });
        this.otpVerified = true;
      } catch (err) {
        const code = err.response?.data?.error;
        if (code === 'expired') this.errorObj.otpErr = ['OTP expired, please resend'];
        else if (code === 'invalid') this.errorObj.otpErr = ['Incorrect OTP, please try again'];
        else this.errorObj.otpErr = ['Verification failed, please try again'];
      } finally {
        this.verifyingOtp = false;
      }
    },
    // Password entry was removed from this form, but /customersdata/ still requires
    // cus_password to be set — generate one automatically so the account can be created.
    // TODO: confirm with backend whether it should generate/hash this instead.
    generateTempPassword() {
      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789!@$%';
      let pw = '';
      for (let i = 0; i < 12; i++) pw += chars.charAt(Math.floor(Math.random() * chars.length));
      return pw;
    },
    resetCheckErr() {
      Object.keys(this.errorObj).forEach(k => this.errorObj[k] = []);
    },
    checkEmptyErr() {
      for (var t in this.errorObj) { if (this.errorObj[t].length !== 0) return false; }
      return true;
    },
    checkForm() {
      this.resetCheckErr();
      if (!this.registerObj.name) this.errorObj.nameErr.push("Name is required");
      else if (!/^[A-Za-z]+$/.test(this.registerObj.name.replace(/\s/g, ""))) this.errorObj.nameErr.push('Name can only contain letters');
      if (!this.registerObj.address) this.errorObj.addressErr.push("Address is required");
      if (!this.registerObj.phone) this.errorObj.phoneErr.push('Phone number is required');
      else if (this.registerObj.phone.length !== 10) this.errorObj.phoneErr.push('Phone number must be 10 digits');
      else if (!/[0-9]{10}/.test(this.registerObj.phone)) this.errorObj.phoneErr.push('Digits only, no spaces');
      if (!this.otpVerified) this.errorObj.otpErr.push('Please verify your mobile number with OTP');
      if (!this.registerObj.nic) this.errorObj.nicErr.push('NIC number is required');
      else if (this.registerObj.nic.length !== 12 &&
        !(this.registerObj.nic.charAt(9).toUpperCase() === 'V' || this.registerObj.nic.charAt(9).toUpperCase() === 'X'))
        this.errorObj.nicErr.push('Please enter a valid NIC number');
      if (!this.registerObj.pro) this.errorObj.proErr.push('Province is required');
      if (!this.registerObj.dis) this.errorObj.disErr.push('District is required');
      if (!this.registerObj.pra_sabha) this.errorObj.praErr.push('Sabha is required');
    },
    async handleSubmit(e) {
      e.preventDefault();
      this.checkForm();
      if (!this.checkEmptyErr()) return;

      // Pad the NIC once and reuse it for both the duplicate check and the submit,
      // since that's the format actually stored in the DB.
      let Nic12 = this.addZeroPadding();
      await this.getMatchUser(Nic12);

      if (this.matchUser) {
        this.accountExists = true;
        this.scrollToTop();
        return;
      }
      this.accountExists = false;

      let baseUrl = this.registerObj.pro === 'PRO1' ? "https://elgservices.lk/newacc" : "https://elgservices.lk/api";
      // let baseUrl = this.registerObj.pro === 'PRO1' ? "https://elgservices.com.lk/acc" : "https://elgservices.com.lk/api";
      //   let baseUrl = this.registerObj.pro === 'PRO1'
      // ? "http://" + window.location.hostname + ":4000/api"
      // : "http://" + window.location.hostname + ":3000/api";
      axios.defaults.baseURL = baseUrl;
      await axios.post("/customersdata/", { cus_name: this.registerObj.name, cus_nic: Nic12, cus_address: this.registerObj.address, cus_email: this.registerObj.email, cus_contact: this.registerObj.phone, cus_password: this.generateTempPassword(), cus_status: this.registerObj.status });
      await axios.post("/addcustomersabha/", { province: this.registerObj.pro, district: this.registerObj.dis, sabha: this.registerObj.pra_sabha, cus_nic: Nic12 });
      this.$router.push("/");
    },
  },
};
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&family=DM+Serif+Display&display=swap');

* { box-sizing: border-box; margin: 0; padding: 0; }

/* ── Page ── */
.register-page {
  min-height: 85vh;
  /* max-height: 90vh; */
  background: #f2f0ec;
  font-family: 'DM Sans', sans-serif;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 0.8rem 1.5rem;
}

/* ── Split Container ── */
.register-container {
  display: grid;
  grid-template-columns: 34% 66%;
  width: 100%;
  max-width: 1100px;
  background: #fff;
  border-radius: 1.4rem;
  overflow: hidden;
  box-shadow: 0 8px 40px rgba(100,50,30,0.12);
  border: 1px solid #e5ddd5;
   min-height: 80vh;
}

/* ── Branding Panel ── */
.branding-panel {
  background: linear-gradient(160deg, #7c2d12 0%, #9a3412 50%, #c2440a 100%);
  padding: 2rem 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
}
.branding-panel::before {
  content: '';
  position: absolute; top: -20%; right: -30%;
  width: 32rem; height: 32rem; border-radius: 50%;
  background: rgba(255,255,255,0.05); pointer-events: none;
}
.branding-panel::after {
  content: '';
  position: absolute; bottom: -15%; left: -20%;
  width: 24rem; height: 24rem; border-radius: 50%;
  background: rgba(0,0,0,0.07); pointer-events: none;
}
.branding-content { position: relative; z-index: 1; }

.brand-gov-badge {
  width: 4rem; height: 4rem; border-radius: 0.8rem;
  background: rgba(255,255,255,0.15);
  border: 2px solid rgba(255,255,255,0.25);
  display: flex; align-items: center; justify-content: center;
  font-family: 'DM Serif Display', serif;
  font-size: 1.5rem; font-weight: 700; color: #fff;
  margin-bottom: 1rem;
}
.brand-title    { font-family: 'DM Serif Display', serif; font-size: 2rem; color: #fff; line-height: 1.2; margin-bottom: 0.4rem; }
.brand-subtitle { font-size: 1.15rem; color: rgba(255,255,255,0.85); margin-bottom: 0.3rem; line-height: 1.5; }
.brand-sinhala  { font-size: 1rem; color: rgba(255,255,255,0.65); margin-bottom: 1.2rem; line-height: 1.5; }

.features-list { display: flex; flex-direction: column; gap: 0.6rem; }
.feature-item {
  display: flex; align-items: flex-start; gap: 0.8rem;
  padding: 0.7rem 0.9rem;
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.13);
  border-radius: 0.7rem; transition: all 0.2s;
}
.feature-item:hover { background: rgba(255,255,255,0.14); transform: translateX(4px); }
.feature-icon { width: 1.8rem; height: 1.8rem; flex-shrink: 0; }
.feature-icon svg { width: 100%; height: 100%; stroke: rgba(255,255,255,0.9); }
.feature-text { display: flex; flex-direction: column; gap: 0.05rem; }
.feature-text strong { font-size: 1.15rem; font-weight: 600; color: #fff; }
.feature-text span   { font-size: 1rem; color: rgba(255,255,255,0.7); }

.branding-footer {
  position: relative; z-index: 1;
  border-top: 1px solid rgba(255,255,255,0.15);
  padding-top: 0.9rem; margin-top: 0.9rem;
}
.branding-footer p { font-size: 1rem; color: rgba(255,255,255,0.6); line-height: 1.5; }

/* ── Form Panel ── */
.form-panel { padding: 1.8rem 2.6rem; overflow-y: auto; }
.form-inner { display: flex; flex-direction: column; }

/* ── Form Header ── */
.form-header {
  display: flex; align-items: flex-start; gap: 1rem;
  margin-bottom: 1.4rem;
}
.form-header-bar {
  width: 4px; min-height: 52px; border-radius: 99px;
  background: linear-gradient(180deg, #7c2d12, #c2440a);
  flex-shrink: 0; margin-top: 3px;
}
.form-breadcrumb { font-size: 1rem; font-weight: 500; letter-spacing: 0.12em; text-transform: uppercase; color: #9a6652; margin: 0 0 0.15rem; }
.form-title    { font-family: 'DM Serif Display', serif; font-size: 2rem; color: #1c0f0a; margin: 0 0 0.15rem; }
.form-subtitle { font-size: 1.15rem; color: #9a8070; margin: 0; }

/* ── Already-Registered Banner ── */
.account-exists-banner {
  display: flex; align-items: flex-start; gap: 0.7rem;
  padding: 0.9rem 1.1rem;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 0.8rem;
  margin-bottom: 1.2rem;
}
.banner-icon { width: 1.6rem; height: 1.6rem; flex-shrink: 0; color: #b91c1c; margin-top: 0.1rem; }
.banner-icon svg { width: 100%; height: 100%; }
.banner-text { display: flex; flex-direction: column; gap: 0.15rem; }
.banner-text strong { font-size: 1.2rem; color: #991b1b; }
.banner-text span { font-size: 1.1rem; color: #7f1d1d; }
.banner-text a { color: #b91c1c; font-weight: 700; text-decoration: underline; }

.fade-enter-active, .fade-leave-active { transition: opacity 0.25s ease; }
.fade-enter, .fade-leave-to { opacity: 0; }

/* ── Section Labels ── */
.section-label {
  display: flex; align-items: center; gap: 0.5rem;
  font-size: 1.1rem; font-weight: 600;
  color: #7c2d12; text-transform: uppercase; letter-spacing: 0.06em;
  margin-bottom: 0.8rem;
}
.section-label svg { width: 1.4rem; height: 1.4rem; stroke: #c2440a; flex-shrink: 0; }

.section-divider { height: 1px; background: #f0e6de; margin: 1rem 0; }

/* ── Field Grids ── */
.field-grid { display: grid; gap: 0.9rem; margin-bottom: 0; }
.two-col   { grid-template-columns: 1fr 1fr; }
.three-col { grid-template-columns: 1fr 1fr 1fr; }

/* ── Field Groups ── */
.field-group { display: flex; flex-direction: column; gap: 0.3rem; }
.field-label { font-size: 1.2rem; font-weight: 600; color: #4a3028; }
.req { color: #c2440a; }

.input-wrap { position: relative; }

.field-input {
  width: 100%;
  padding: 0.65rem 1rem 0.65rem 3.1rem;
  font-size: 1.3rem;
  font-family: 'DM Sans', sans-serif;
  color: #1c0f0a;
  background: #faf8f6;
  border: 2px solid #e5ddd5;
  border-radius: 0.7rem;
  transition: all 0.2s;
}
.field-input:focus {
  outline: none; border-color: #c2440a;
  background: #fff; box-shadow: 0 0 0 3px rgba(194,68,10,0.09);
}
.field-input.filled { background: #fff; border-color: #c2440a; }
.field-input::placeholder { color: #b0a09a; }
.field-input:disabled { opacity: 0.75; cursor: not-allowed; }

.input-icon {
  position: absolute; left: 0.9rem; top: 50%; transform: translateY(-50%);
  width: 1.5rem; height: 1.5rem; color: #9a8070; pointer-events: none;
}
.input-icon svg { width: 100%; height: 100%; }

/* Select */
.select-input { appearance: none; -webkit-appearance: none; cursor: pointer; padding-right: 2.8rem; }
.select-chevron {
  position: absolute; right: 0.9rem; top: 50%; transform: translateY(-50%);
  width: 1.4rem; height: 1.4rem; color: #9a8070; pointer-events: none;
}
.select-chevron svg { width: 100%; height: 100%; }

/* ── OTP ── */
.otp-wrap { display: flex; align-items: stretch; gap: 0.6rem; }
.otp-wrap .otp-phone-input { flex: 1; }
.otp-send-btn {
  flex-shrink: 0;
  padding: 0 1.1rem;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.1rem; font-weight: 700;
  color: #c2440a;
  background: #fff;
  border: 2px solid #c2440a;
  border-radius: 0.7rem;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}
.otp-send-btn:hover:not(:disabled) { background: rgba(194,68,10,0.08); }
.otp-send-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.otp-send-btn.verified { color: #15803d; border-color: #15803d; background: rgba(21,128,61,0.08); cursor: default; }

.otp-verify-row { display: flex; gap: 0.6rem; margin-top: 0.5rem; }
.otp-code-input { flex: 1; padding-left: 1rem; letter-spacing: 0.2em; }
.otp-verify-btn {
  flex-shrink: 0;
  padding: 0 1.3rem;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.1rem; font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  border: none; border-radius: 0.7rem;
  cursor: pointer;
  transition: all 0.2s;
}
.otp-verify-btn:disabled { opacity: 0.5; cursor: not-allowed; }

.otp-hint { font-size: 1.1rem; color: #9a8070; margin-top: 0.3rem; }
.otp-verified-msg {
  display: flex; align-items: center; gap: 0.4rem;
  font-size: 1.1rem; font-weight: 600; color: #15803d; margin-top: 0.3rem;
}
.otp-verified-msg svg { width: 1.2rem; height: 1.2rem; }

/* Error */
.error-mess { font-size: 1.15rem; color: #b91c1c; margin: 0; }
.error-mess::before { content: '⚠ '; }

/* ── Form Actions ── */
.form-actions {
  display: flex; align-items: center; justify-content: space-between;
  gap: 1rem; flex-wrap: wrap;
  margin-top: 1.2rem; padding-top: 1rem;
  border-top: 1px solid #f0ebe3;
}
.login-hint { font-size: 1.25rem; color: #7a6258; margin: 0; }
.login-link { color: #c2440a; font-weight: 600; text-decoration: none; }
.login-link:hover { text-decoration: underline; }

.submit-btn {
  display: inline-flex; align-items: center; gap: 0.6rem;
  padding: 0.85rem 2.2rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border: none; border-radius: 0.8rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.4rem; font-weight: 700;
  cursor: pointer; box-shadow: 0 4px 16px rgba(124,45,18,0.28);
  transition: all 0.2s;
}
.submit-btn svg { width: 1.7rem; height: 1.7rem; }
.submit-btn:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(124,45,18,0.38); }
.submit-btn:disabled { opacity: 0.5; cursor: not-allowed; box-shadow: none; }

/* Panel Footer */
.panel-footer {
  margin-top: 1rem; padding-top: 0.9rem;
  border-top: 1px solid #f0ebe3; text-align: center;
}
.panel-footer p { font-size: 1.05rem; color: #9a8070; }

/* ── Responsive ── */
@media (max-width: 1000px) {
  .register-container { grid-template-columns: 1fr; max-width: 620px; }
  .branding-panel { display: none; }
  .form-panel { padding: 2rem 1.8rem; }
}
@media (max-width: 600px) {
  .register-page { padding: 0.5rem; }
  .form-panel { padding: 1.5rem 1.2rem; }
  .two-col, .three-col { grid-template-columns: 1fr; }
  .otp-wrap { flex-wrap: wrap; }
  .otp-send-btn { width: 100%; }
  .otp-verify-row { flex-direction: column; }
  .form-actions { flex-direction: column; align-items: flex-start; }
  .submit-btn { width: 100%; justify-content: center; }
}
</style>